export default "__VITE_ASSET__cGrduM7N__"